export default "__VITE_ASSET__CoA8rIt7__"